import { BASE_API } from './base';
import axios from 'axios';

/**
 *
 * @param {any} method
 * @param {any} url
 * @param {any} data
 * @param {any} headers
 */
function request(method, url, data, config, disallowCustomHeader) {
  // more config options for axios, please refer to this link:
  // https://www.npmjs.com/package/axios#axiosrequestconfig
  let headers = {};
  let passHeader = true;
  if (disallowCustomHeader !== undefined) {
    if (disallowCustomHeader !== null && disallowCustomHeader) {
      passHeader = false;
    }
  }
  if (passHeader) {
    headers['Cache-Control'] = 'no-cache';
    headers['APL_Token'] = sessionStorage.getItem('apl_token') === null ? '' : sessionStorage.getItem('apl_token');
  }
  return axios({
    method,
    url: url.startsWith('https://') || url.startsWith('http://') ? url : BASE_API().trimRight('/') + url,
    data,
    headers: headers,
    ...config,
  }).then(function (response) {
    if (passHeader) {
      let token = response.headers['apl_token'];
      let tokenTimeout = response.headers['apl_token_timeout'];
      sessionStorage.setItem('apl_token', token);
      sessionStorage.setItem('apl_token_timeout', tokenTimeout);
    }
    return response;
  });
}

export function get(url, data, config, disallowCustomHeader) {
  return request('get', url, data, config, disallowCustomHeader);
}

export function post(url, data, config, disallowCustomHeader) {
  return request('post', url, data, config, disallowCustomHeader);
}

export function del(url, data, config, disallowCustomHeader) {
  return request('delete', url, data, config, disallowCustomHeader);
}

export function put(url, data, config, disallowCustomHeader) {
  return request('put', url, data, config, disallowCustomHeader);
}